import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'src/app/utils/services/dialog.service';
import { DataTableDirective } from 'angular-datatables';
import { DataTablesResponse } from 'src/app/interfaces/data-table-response.interface';
import { environment } from 'src/environments/environment';
import { CetateanAccountsService } from './cetatean-accounts.service';
import { ICitizenInfo } from './cetatean-accounts.interface';
import { helper } from 'src/environments/helper';
import Swal from 'sweetalert2';
import { InfoCetateanComponent } from './info-cetatean/info-cetatean.component';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
    selector: 'app-cetatean-accounts',
    templateUrl: './cetatean-accounts.component.html',
    styleUrls: ['./cetatean-accounts.component.scss'],
})
export class CetateanAccountsComponent {
    @ViewChild(DataTableDirective, { static: false })
    dtElement!: DataTableDirective;
    isLoading = false;
    showCard = false;

    filtersForm!: FormGroup;

    helper = helper;

    dtOptions: any = {};
    dtTrigger: Subject<any> = new Subject<any>();
    dtInstance!: DataTables.Api;

    parameters: { key: string; value: string }[] = [
        { key: '--Alegeți--', value: '-1' },
        { key: 'Da', value: '1' },
        { key: 'Nu', value: '0' },
    ];

    initialFiltersFormValues = {
        cnp_cui: '',
        name: '',
        phone: '',
        email: '',
        active: '-1',
        approved: '-1',
    };

    buildFiltersForm() {
        this.filtersForm = new FormGroup({
            cnp_cui: new FormControl(''),
            name: new FormControl(''),
            phone: new FormControl(''),
            email: new FormControl(''),
            active: new FormControl('-1'),
            approved: new FormControl('-1'),
        });
    }

    toggleCard() {
        this.showCard = !this.showCard;
    }

    resetForm() {
        this.filtersForm.reset(this.initialFiltersFormValues);

        this.rerenderDT();
        this.showCard = true;
    }

    applyFilters(): void {
        this.showCard = false;
        this.rerenderDT(true);
    }

    dtLink =
        environment.interop.basePath +
        environment.interop.platform.nomenclatoare.citizen.getCitizensDT;

    constructor(
        private http: HttpClient,
        private dialog: MatDialog,
        private dialogService: DialogService,
        private citizenService: CetateanAccountsService
    ) { }

    ngOnInit(): void {
        this.buildFiltersForm();
        this.renderDT();
    }

    ngAfterViewInit(): void {
        this.dtTrigger.next('');
    }

    ngOnDestroy(): void {
        this.dtTrigger.unsubscribe();
    }

    renderDT() {
        this.isLoading = true;
        this.dtOptions = {
            serverSide: true,
            searching: false,
            pageLength: 25,
            responsive: true,

            ajax: (dataTablesParameters: any, callback: any) => {
                this.isLoading = true;
                dataTablesParameters.filters = this.filtersForm.value;

                this.http
                    .post<DataTablesResponse>(this.dtLink, dataTablesParameters)
                    .subscribe((resp: any) => {
                        this.isLoading = false;
                        callback({
                            recordsTotal: resp.data.recordsTotal,
                            recordsFiltered: resp.data.recordsFiltered,
                            data: resp.data.data,
                        });
                    });
            },
            language: environment.config.romanianLanguageDataTable,
            columns: [
                {
                    title: 'ID',
                    data: 'id_cetatean',
                },
                {
                    title: 'Nume',
                    data: 'name',
                },
                {
                    title: 'Email',
                    data: 'email',
                },
                {
                    title: 'Acțiuni',
                    className: 'all',
                    data: null,
                    orderable: false,
                    render: () => {
                        return `
            <div class="d-flex align-center justify-content-center">
                    <button class="action-btn view ms-1">
                        <img class="btn-img" src="../../../../assets/icons/view.svg" alt="view"/>
                    </button>
                    </div>
                        `;
                    },
                },
            ],
            rowCallback: (row: Node, data: any[] | any) => {
                const lastTd = (row as HTMLElement).querySelector('td:last-child');
                const viewicon = lastTd?.querySelector('.view');

                if (viewicon) {
                    viewicon.addEventListener('click', () => {
                        this.openInfoDialog(data);
                    });
                }

                return row;
            },
        };
    }

    rerenderDT(paginate = false): void {
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
            dtInstance.draw(paginate);
        });
        this.showCard = false;
    }

    openInfoDialog(data: ICitizenInfo) {
        const dialogRef = this.dialog.open(InfoCetateanComponent, {
            minHeight: '100vh',
            maxHeight: '100vh',
            minWidth: '100vw',
            maxWidth: '100vw',
            disableClose: true,
            data,
        });

        dialogRef.afterClosed().subscribe(({ success }: { success: boolean }) => {
            if (success) {
                this.rerenderDT();
            }
        });
    }
}
